"use client";
import { V as h, a as i, b as r } from "./prod-BQ6GYK89.js";
const c = /,/g, n = "-->";
class u extends h {
  parse(s, e) {
    if (s === "")
      this.c && (this.l.push(this.c), this.h.onCue?.(this.c), this.c = null), this.e = i.None;
    else if (this.e === i.Cue)
      this.c.text += (this.c.text ? `
` : "") + s;
    else if (s.includes(n)) {
      const t = this.q(s, e);
      t && (this.c = new r(t[0], t[1], t[2].join(" ")), this.c.id = this.n, this.e = i.Cue);
    }
    this.n = s;
  }
  q(s, e) {
    return super.q(s.replace(c, "."), e);
  }
}
function T() {
  return new u();
}
export {
  u as SRTParser,
  T as default
};
